var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationUserBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 52h-1C17.42 52 8 42.579 8 31s9.42-21 21-21c6.107 0 11.704 2.61 15.76 7.35l-1.52 1.3C39.57 14.361 34.513 12 29 12c-10.477 0-19 8.523-19 19s8.523 19 19 19h1v2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 70h-2v-7c0-8.01 4.446-9.7 9.152-11.488 1.743-.662 3.544-1.347 5.352-2.38l.992 1.736c-1.943 1.111-3.904 1.856-5.633 2.513C31.128 55.181 28 56.369 28 63v7M72 70h-2v-7c0-6.631-3.128-7.819-7.863-9.619-1.729-.657-3.69-1.402-5.633-2.513l.992-1.736c1.808 1.033 3.609 1.718 5.352 2.38C67.554 53.3 72 54.99 72 63v7",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 50.882l3.803 1.901 2.91-2.91-1.187-1.78-5.526.921-5.526-.921-1.187 1.78 2.91 2.91L49 50.882zm4.197 4.335L49 53.118l-4.197 2.099-5.09-5.09 2.813-4.22L49 46.986l6.474-1.079 2.813 4.22-5.09 5.09z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M53 47h2v-4h-2zM43 47h2v-4h-2zM48 62h2v-2h-2zM48 58h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 45c-.132 0-3.261-.013-5.447-1.105l-.108-.063c-.137-.092-3.384-2.333-4.435-9.69L39 34v-4h2v3.929c.861 5.917 3.201 7.96 3.519 8.212 1.762.844 4.455.859 4.482.859.025 0 2.717-.015 4.478-.858.313-.25 2.661-2.305 3.521-8.213V30h2l-.01 4.142c-1.051 7.357-4.298 9.598-4.435 9.69l-.108.063C52.261 44.987 49.132 45 49 45M59 30h-2c0-5.532-2.467-8-8-8-5.533 0-8 2.468-8 8h-2c0-6.636 3.364-10 10-10s10 3.364 10 10",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M54.045 33.096l-10-4-3.598 1.799-.894-1.79 4.402-2.201 10 4 3.598-1.799.894 1.79-4.402 2.201M34 70h2v-6h-2zM62 70h2v-6h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 29c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.932 43.327a1 1 0 01-.986-.832A2.985 2.985 0 0029 40a2.985 2.985 0 00-2.946 2.495.997.997 0 01-1.314.776 13.09 13.09 0 01-8.012-8.011 1.004 1.004 0 01.777-1.314 2.985 2.985 0 000-5.892 1 1 0 01-.777-1.314 13.09 13.09 0 018.012-8.011.992.992 0 01.837.084.993.993 0 01.477.692A2.985 2.985 0 0029 22c1.461 0 2.7-1.049 2.946-2.495a.993.993 0 01.477-.692.989.989 0 01.837-.084 12.993 12.993 0 015.412 3.604l-1.489 1.334a11.051 11.051 0 00-3.612-2.661A4.973 4.973 0 0129 24a4.976 4.976 0 01-4.571-2.993 11.113 11.113 0 00-5.422 5.422A4.976 4.976 0 0122 31a4.976 4.976 0 01-2.993 4.571 11.113 11.113 0 005.422 5.422A4.976 4.976 0 0129 38a4.975 4.975 0 014.571 2.994 10.944 10.944 0 002.762-1.81l1.334 1.488a12.898 12.898 0 01-4.407 2.599.98.98 0 01-.328.056M28 16h2v-2h-2zM12 32h2v-2h-2zM28 48h2v-2h-2z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationUserBadge;